import { BFF_API_ROUTES } from 'constants/routes';

import { baseRTKApi } from 'shared/api/baseApi';

import type { StateUser } from '../types';

export const queries = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    getUserInfo: build.query<StateUser['account'], void>({
      query: () => ({
        url: BFF_API_ROUTES.account,
      }),
      extraOptions: { maxRetries: 0 },
    }),
    getIfUserHasEsia: build.query<boolean, void>({
      query: () => BFF_API_ROUTES.getIfUserHasEsia,
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const getUserInfo = queries.useLazyGetUserInfoQuery;
export const { useGetIfUserHasEsiaQuery } = queries;
